module.exports = __webpack_public_path__ + "img/person_3.fe718d55.jpeg";